<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside mb-3" style="top: 120px;">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-12 col-xl-9">
                        <div class="d-sm-flex d-block justify-content-between align-items-end border-bottom mb-3">
                            <h2>Équipe - {{ team.name }}</h2>
                            <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'general' }"
                                        @click="this.activeTab='general'" href="javascript:void(0)">Général</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'team_members' }"
                                        @click="this.activeTab='team_members'" href="javascript:void(0)">Joueurs</a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content pt-0 mb-5">
                            <div v-if="activeTab === 'general'" class="tab-pane fade show active">
                                <form @submit.prevent="editTeam">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="d-flex flex-row align-items-top mt-1 mb-3">
                                                <img :src="previewUrl || defaultImage" class="mr-1" style="width: 70px;height: 70px;" />
                                                <div class="form-group card-label h-100 mb-3">
                                                    <label>Nom de l'Équipe</label>
                                                    <span class="input form-control">{{team.name}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Créée le</label>
                                                <span class="input form-control">{{ formatDateTime(team.created_at).date }}</span>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Délégation</label>
                                                <span class="input form-control">{{team.delegation}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Format</label>
                                                <span class="input form-control">{{team.format}}</span>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Formation</label>
                                                <span class="input form-control">{{team.formation}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div v-if="activeTab === 'team_members'" class="tab-pane fade show active">
                                <div v-if="teamMembers.length !== 0" class="table-responsive text-xs py-2 px-0">
                                    <table class="table table-hover table-center mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th>Nom Joueur</th>
                                                <th>Role</th>
                                                <th>Position</th>
                                                <th>Poste(s) Préférée(s)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in teamMembers" :key="item.id">
                                                <td>
                                                    <span>
                                                        {{ (item.player.id !== player.id) ? item.player.name : 'Moi' }}
                                                        <b>
                                                            {{ (item.player.id === team.captain_id) ? ' (C)' : '' }}
                                                            {{ (item.player.id === team.owner_id) ? ' (Manager)' : '' }}
                                                        </b>
                                                    </span>
                                                </td>
                                                <td>{{ membershipRoles[item.role] }}</td>
                                                <td>
                                                    <span v-if="item.lineup_position" class="badge p-2 ml-1" :class="playerPositions[item.lineup_position]['class']">
                                                        {{ playerPositions[item.lineup_position]['abbr'] }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-for="position in item.player.position.split(',').map(p => p.trim())" class="badge p-2 ml-1" :class="playerPositions[position] ? playerPositions[position]['class'] : ''">
                                                        {{ playerPositions[position] ? playerPositions[position]['abbr'] : position }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style>
.nav-tabs.nav-justified > li > a {
    width: 100% !important;
}
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import defaultImagePath from '@/assets/img/default-team-logo.png'

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    props: ['id'],
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
    },
    data() {
        return {
            activeTab: 'general',
            defaultImage: defaultImagePath,
            previewUrl: null,
            player: {},
            team: {},
            teamMembers: [],
            membershipRoles: {
                'captain': 'Capitaine',
                'starting': 'Titulaire',
                'substitute': 'Remplaçant'
            },
            playerPositions: {
                'goalkeeper': {'abbr': 'G', 'class': 'bg-warning-light'},
                'defender': {'abbr': 'DF', 'class': 'bg-primary-light'},
                'midfielder': {'abbr': 'ML', 'class': 'bg-success-light'},
                'forward': {'abbr': 'AT', 'class': 'bg-danger-light'}
            },
        }
    },
    mounted() {
        this.getTeam()
        this.getMyPlayerProfile()
    },
    methods: {
        async getTeam() {
            await api.get('/private/teams/'+this.id)
                .then(response => {
                    const result = response.data
                    this.team = result
                    this.previewUrl = this.team.logo
                    this.teamMembers = this.team.memberships.filter(membership => membership.status == 'accepted')
                        .sort((a, b) => a.role.localeCompare(b.role))
                })
        },
        async getMyPlayerProfile() {
            api.get('/private/players/me')
                .then(response => {
                    const result = response.data
                    this.player = result
                })
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: formattedDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
    },
    watch: {}
};
</script>
